import { BaseUrl } from './base_url_enum'
import Api from './index'
import { ILoginApiResponse, ILoginApiSuccessResponse } from './types/login_api'
import { IPostOnboardingRequest } from './types/sessions'

export const registerEmail = async (
  email: string
): Promise<ILoginApiResponse<unknown>> => await Api('POST', 'email-registration', BaseUrl.Login, {
  email
})

export const forgotPassword = async (
  email: string
): Promise<ILoginApiResponse<unknown>> => await Api('POST', 'forgot-password', BaseUrl.Login, {
  email
})

export const changePassword = async (
  oldPassword: string,
  password: string,
  passwordConfirmation: string
): Promise<ILoginApiResponse<ILoginApiSuccessResponse>> => await Api('PUT', 'user/password', BaseUrl.Login, {
  oldPassword,
  password,
  passwordConfirmation
})

export const logout = async (): Promise<ILoginApiResponse<unknown>> => await Api('POST', 'logout', BaseUrl.Login)

export const forgotPasswordVerify = async (
  email: string,
  password: string,
  passwordConfirmation: string,
  token: string
): Promise<ILoginApiResponse<unknown>> => await Api('POST', 'forgot-password-verify', BaseUrl.Login, {
  email,
  password,
  passwordConfirmation,
  token
})

export const verifyRegistration = async (
  email: string,
  password: string,
  passwordConfirmation: string,
  token: string
): Promise<ILoginApiResponse<ILoginApiSuccessResponse>> => await Api('POST', 'verify-registration', BaseUrl.Login, {
  email,
  password,
  passwordConfirmation,
  token
})

export const login = async (
  email: string,
  password: string
): Promise<ILoginApiResponse<ILoginApiSuccessResponse>> => await Api('POST', 'login', BaseUrl.Login, {
  email,
  password
})

export const postOnboarding = async (
  data: IPostOnboardingRequest
): Promise<ILoginApiResponse<ILoginApiSuccessResponse>> => await Api('POST', 'onboarding', BaseUrl.Login, data)

export const verifyInvite = async (
  email: string,
  relationNumber: string,
  token: string,
  type: string,
  password: string,
  passwordConfirmation: string
): Promise<ILoginApiResponse<ILoginApiSuccessResponse>> => await Api('POST', 'user/verify-invite', BaseUrl.Login, {
  email,
  relationNumber,
  token,
  type,
  password,
  passwordConfirmation
})

export const verifyInviteExisting = async (
  email: string,
  relationNumber: string,
  token: string,
  type: string
): Promise<ILoginApiResponse<ILoginApiSuccessResponse>> => await Api('POST', 'user/verify-invite', BaseUrl.Login, {
  email,
  relationNumber,
  token,
  type
})

export const unblockUser = async (
  email: string,
  password: string,
  passwordConfirmation: string,
  token: string
): Promise<ILoginApiResponse<ILoginApiSuccessResponse>> => await Api('POST', 'unblock', BaseUrl.Login, {
  email,
  password,
  passwordConfirmation,
  token
})
